/**
 * Model for a product type (e.g. Apparel, Floor Pass, Raffle Ticket, Other, etc)
 */
export class ProductTypeVerification {
    public id: string = null;
    public name: string = null;
    public productTypeId: string = null;
    public siteId: number = null;
    public verificationCode: string = null;

    /**
     * Clone the object. This is used to prevent object reference issues
     */
    public clone(): ProductTypeVerification {
        const clone: ProductTypeVerification = new ProductTypeVerification();
        clone.id = this.id;
        clone.name = this.name;
        clone.productTypeId = this.productTypeId;
        clone.verificationCode = this.verificationCode;
        clone.siteId = this.siteId;

        return clone;
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: Object): ProductTypeVerification {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.productTypeId = attrs['productTypeId'];
        this.verificationCode = attrs['verificationCode'];
        this.siteId = parseInt(attrs['siteId'], null);

        return this;
    }
}
